export default __webpack_public_path__ + "static/media/circle-avatar-info.1db6adc0.svg";